"use strict";

exports.__esModule = true;

require('./bullseye.css');

exports.default = {
  "bullseye": "pf-l-bullseye"
};